import { gql, useLazyQuery, useQuery } from '@apollo/client';
import { INTERACTION_FIELDS } from "../../fragments";
export const INTERACTION_READ = gql`
  ${INTERACTION_FIELDS}
  query interactionRead($id: Long) {
    interaction_read(id: $id) {
      ...InteractionFields
    }
  }
`;
export const useInteractionReadLazyQuery = options => {
  return useLazyQuery(INTERACTION_READ, options);
};
export const useInteractionReadQuery = options => {
  return useQuery(INTERACTION_READ, options);
};